import React from "react";
import ConfirmationModal from "../../../../common/common_modal/confirmationModal/ConfirmationModal";

const LogoutConfirmationModal = ({ show = true, onHide, onButtonClick }) => {
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      title={"Logout Confirmation"}
      statusTitle={"Ready To Logout?"}
      message={
        "Your session will be ended. You can login again anytime using your credentials."
      }
      buttonText={"Proceed Now"}
      onButtonClick={onButtonClick}
      className="LogoutConfirmationModal"
    />
  );
};

export default LogoutConfirmationModal;
